export const shouldRedirectToPlan = (user) => {
    return user.isOwner && user.isTrial == false && user.isSubscribed == false
}